<template>
    <y-rogue-wrapper
        name="profileWishlist"
        type="simple"
        :title="$t('dashboard.wishlist.title')"
        raised
    />
</template>

<script>
    export default {
        name: 'DashboardWishlist',

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('dashboard.wishlist.title'),
            };
        },
    };
</script>
